import {
  CLEAR_MANPOWER_ATTENDANCE_REPORT_DATA,
  CREATE_ATTENDANCE_SUCCESS,
  FETCH_ATTENDANCE_SUCCESS, FETCH_MANPOWER_ATTENDANCE_REPORT_DATA_SUCCESS,
  GET_ATTENDANCE_SUCCESS,
  SAVE_ATTENDANCE_QUERY
} from "../../constants/ActionTypes";
import {message} from "antd";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  attendance: {},
  query: {},
  reports: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_ATTENDANCE_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_ATTENDANCE_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_ATTENDANCE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_ATTENDANCE_SUCCESS: {
      return {
        ...state,
        attendance: action.data,
      }
    }

    case FETCH_MANPOWER_ATTENDANCE_REPORT_DATA_SUCCESS: {
      if (action.data.length === 0) {
        message.error(
          "No data found for given query, please try with different parameters!"
        );
      }
      return {
        ...state,
        reports: action.data
      };
    }

    case CLEAR_MANPOWER_ATTENDANCE_REPORT_DATA: {
      return {
        ...state,
        reports: []
      };
    }

    default:
      return state;
  }
}
